/*
    author：peter (185832959@qq.com)
    date：2018-07-04
*/
import Vue from 'vue'
import api from 'api'
import config from 'common/config'
import { MessageBox, Message } from 'element-ui'
import { checkAcls } from 'common/acl'
import * as utils from 'common/utils'
import Public from 'common/public'
import JSEncrypt from 'src/common/jsencrypt.js'
import storage from 'unit/storage'
import { mixins } from 'vue-class-component'

// @Component
export default class Base extends mixins(Vue, Public) {
    api = api
    config = config
    utils = utils
    jsEncrypt = new JSEncrypt()
    storage = storage
    // 页面跳转
    goTo(options) {
        this.$router.push(options)
    }

    /**
     * sleep 定时器
     * @param {number} time
     * @returns {Promise}
     */
    sleep(time = 0) {
        return new Promise((resolve) => {
            let timeId = setTimeout(function () {
                resolve(timeId)
            }, time)
        })
    }

    /**
     * alert
     * @param {string} message  提示内容
     * @param {string} title    标题
     * @param {object} options  alert参数
     */
    alert(message, title = '提示', options) {
        let defOpts = {
            confirmButtonText: '确定',
            confirmButtonClass: 'el-button--primary',
            customClass: 'message-box',
            type: ''
        }
        defOpts = { ...defOpts, ...options }
        return new Promise(async (resolve) => {
            try {
                await MessageBox.alert(message, title, defOpts)
            } catch (error) {
                resolve(false)
                return
            }
            resolve(true)
        })
    }

    /**
     * confirm
     * @param {string} message  确认内容
     * @param {string} title    标题
     * @param {object} options  confirm参数
     * @return {Promise}
     * @example
     *  this.confirm('确认').then(confirm => {
     *      if (confirm) {
     *          ...
     *      }
     *  })
     */
    confirm(message, title = '提示', options) {
        let defOpts = {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'el-button--danger',
            customClass: 'message-box',
            type: 'warning'
        }
        defOpts = { ...defOpts, ...options }
        return new Promise(async (resolve) => {
            try {
                await MessageBox.confirm(message, title, defOpts)
            } catch (error) {
                resolve(false)
                return
            }
            resolve(true)
        })
    }

    /**
     * 将 map 转换成 select 选项
     * @param {*} obj
     */
    mapToOptions(obj) {
        let res = []
        Object.keys(obj).forEach((key) => {
            res.push({
                value: String(key),
                label: obj[key]
            })
        })
        return res
    }

    /**
     * validate form
     * @param formName
     */
    validate(refName) {
        return new Promise((resolve) => {
            let ref = refName
            if (typeof refName === 'string') {
                ref = this.$refs[refName]
            }
            ref.validate((valid) => {
                resolve(valid)
            })
        })
    }

    /**
     * 权限判断
     * @param {string[]} acls     权限数组
     * @returns {Boolean}
     * @example
     *      <span v-if="checkAcls(['permission_name', ...])">
     *          ...
     *      </span>
     */
    checkAcls(acls = []) {
        return checkAcls(acls)
    }

    /**
     * 新开页签
     *
     * @param {*} path
     * @memberof Base
     */
    // eslint-disable-next-line no-dupe-class-members
    open(path) {
        let templateWindow = window.open()
        templateWindow.location = `/lzauth${path}`
    }

    /**
     * 获取公钥
     */
    // initPublicKey() {
    //     this.api.userApi.getPublicKey().then(data => {
    //         let key = ''
    //         let rowUnit = 64
    //         let rowNum = parseInt(data.length % rowUnit === 0 ? data.length / rowUnit : (data.length / rowUnit + 1))
    //         key += '-----BEGIN PUBLIC KEY----- \n'
    //         for (let i = 0; i < rowNum; i++) {
    //             let beginIndex = i * rowUnit
    //             let endIndex = (beginIndex + rowUnit) > data.length ? data.length : (beginIndex + rowUnit)
    //             let rowData = data.substring(beginIndex, endIndex)
    //             key += rowData + '\n'
    //         }
    //         key += '\n-----END PUBLIC KEY-----'
    //         this.jsEncrypt.setPublicKey(key)
    //     })
    // }

    /**
     * 根据值过滤数组 返回对象
     *
     * @param {*} arr 需要过滤的数组
     * @param {*} val 过滤的值
     * @returns
     * @memberof Base
     */
    filterArray(arr, val) {
        return arr.find((ele) => {
            return ele.value === val
        })
    }

    /**
     * confirm
     * @param {string} message  提示内容
     * @param {string} title    标题
     * @param {object} options  延迟时间后执行回调函数
     * @return {Promise}
     * @example
     *  this.message('操作成功', { type: 'success' }, () => {  ...dosomething })
     */
    message(tips, opt, callback) {
        let defOpts = {
            type: `${opt.type}`,
            dangerouslyUseHTMLString: true,
            customClass: `${opt.type}`,
            iconClass: `msg-${opt.type}`,
            duration: 1800,
            message: `<div class="p1">${tips}</div>`,
            onClose: callback
        }
        return new Promise(async (resolve) => {
            try {
                await Message(defOpts)
            } catch (error) {
                resolve(false)
                return
            }
            resolve(true)
        })
    }
}



// WEBPACK FOOTER //
// ./src/views/base.js